import { createFileRoute } from '@tanstack/react-router';
import { DesmosAccessPage } from '@/features/desmos/DesmosAccessPage';
import { requireRouteAccess } from '@/lib/routeGuards';

export const Route = createFileRoute('/_authed/admin/desmos')({
  beforeLoad: () => requireRouteAccess('/admin/desmos'),
  component: DesmosAccessPage,
});
